import { useContext } from "react";
import { authContext } from "./authContext";

/** @LearningJourney Authentication 11 - Redirects to login; pass redirectBackTo so user returns after auth */
export function useRedirectToAuth() {
  const context = useContext(authContext);
  if (!context) {
    throw new Error("AuthContext not initialised");
  }
  return context.client.redirectToAuth.bind(context.client);
}
